import React from "react";
import { Copy, Eye } from "lucide-react";

export default function ApiKey() {
  return (
    <div className="flex-1 p-8 bg-white">
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">API Key</h2>
        <p className="text-sm text-gray-500 leading-relaxed max-w-4xl">
          API Key、签名生成类是接入API的必要条件，涉及商品权益的使用，它们共同确保了用户数据的准确性、安全性和完整性，为API的稳定运行提供了有力保障。
          API Key包含openID、RSA公钥，请妥善保存。不要轻易与他人共享，或将其暴露在浏览器或其他客户端代码中。
        </p>
      </div>

      <div className="overflow-hidden border border-gray-100 rounded-lg shadow-sm">
        <table className="w-full text-left border-collapse text-sm">
          <thead className="bg-gray-50 text-gray-600 font-medium">
            <tr>
              <th className="px-6 py-3 border-b border-gray-100">序号</th>
              <th className="px-6 py-3 border-b border-gray-100">openID</th>
              <th className="px-6 py-3 border-b border-gray-100">RSA公钥</th>
              <th className="px-6 py-3 border-b border-gray-100">创建日期</th>
              <th className="px-6 py-3 border-b border-gray-100">最近使用日期</th>
              <th className="px-6 py-3 border-b border-gray-100">操作</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            <tr className="hover:bg-gray-50 transition-colors">
              <td className="px-6 py-4 border-b border-gray-50">1</td>
              <td className="px-6 py-4 border-b border-gray-50">KJS***</td>
              <td className="px-6 py-4 border-b border-gray-50">4e1b********6b94</td>
              <td className="px-6 py-4 border-b border-gray-50">2026-04-15 15:17:56</td>
              <td className="px-6 py-4 border-b border-gray-50">2026-04-21 13:59:44</td>
              <td className="px-6 py-4 border-b border-gray-50">
                <button className="text-blue-600 hover:text-blue-700 flex items-center gap-1">
                  <Eye className="w-3.5 h-3.5" />
                  查看
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-8 p-6 bg-blue-50/50 rounded-xl border border-blue-100 max-w-sm">
        <h4 className="text-sm font-semibold text-gray-800 mb-2">签名生成类</h4>
        <button className="text-blue-600 hover:text-blue-700 text-sm font-medium">查看</button>
      </div>
    </div>
  );
}
